import { FormFormattedField } from 'components/Form';
import { Field } from 'react-final-form';
import { normalizeFormattedField } from 'utils';
import { useIsAlternativeAuctionSelected } from '../hooks/useIsAlternativeAuctionSelected';
import { composeValidators } from 'utils/validators';
import { useStartingBidValidator } from 'hooks/useGetValidators';
import { useSelectedAuction } from '../hooks/useSelectedAuction';

type Props = {
  vehicleId: number;
};

export const StartingBidField = ({ vehicleId }: Props) => {
  const isAlternativeAuction = useIsAlternativeAuctionSelected(vehicleId);
  const auctionType = useSelectedAuction(vehicleId);

  const startingBidValidation = useStartingBidValidator(auctionType);

  return (
    <Field
      name="starting_bid"
      component={FormFormattedField}
      parse={normalizeFormattedField}
      prefix="$"
      thousandSeparator
      validate={composeValidators(...startingBidValidation)}
      label={isAlternativeAuction ? 'Starting Offer' : 'Starting Bid'}
      styleVariant="filled"
    />
  );
};
